import { createApi } from '@reduxjs/toolkit/query/react';
import { AuthContext, CacheTags } from 'types';
import { OdinBaseQuery } from './core';
// import { selectUser, setAuth } from '../app/authSlice';

export const LOGIN_CACHE_KEY = 'login'; // must match login endpoint name below

export interface LoginAttempt {
  email: string;
  password: string;
}

export const loginApi = createApi({
  reducerPath: 'login',
  baseQuery: OdinBaseQuery,
  tagTypes: [CacheTags.login],
  endpoints: (builder) => ({
    login: builder.mutation<AuthContext, LoginAttempt>({
      query: (payload) => ({
        url: '/api/login',
        method: 'POST',
        body: payload,
      }),
    }),
    refreshToken: builder.mutation<
      Omit<AuthContext, 'user'>,
      { sub: string; refreshToken: string }
    >({
      query: (payload) => ({
        url: '/api/refresh-token',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const { useLoginMutation } = loginApi;
